export const SEED_CONTACTS = 'SEED_CONTACTS';
export const CONTACTS_DELETE_SUCCESS = 'CONTACTS_DELETE_SUCCESS';
export const CONTACTS_SET_TAGS_SUCCESS = 'CONTACTS_SET_TAGS_SUCCESS';
export const CONTACTS_DELETE_TAGS_SUCCESS = 'CONTACTS_DELETE_TAGS_SUCCESS';
export const CONTACTS_SET_STAGE_SUCCESS = 'CONTACTS_SET_STAGE_SUCCESS';
export const CONTACTS_ASSIGN_SUCCESS = 'CONTACTS_ASSIGN_SUCCESS';
export const CONTACTS_SET_NETWORK_TYPE_SUCCESS = 'CONTACTS_SET_NETWORK_TYPE_SUCCESS';
